import { createContext } from 'react';

import type { SankeyChartNodesProps } from '../types/sankey-props.js';

export const SankeyNodesContext = createContext<SankeyChartNodesProps>({});

SankeyNodesContext['displayName'] = 'SankeyNodesContext';
